// Gallery.jsx
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // Added
import { motion } from 'framer-motion';
import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";

// === IMAGES ===
import galleryHeroImage from '../assets/Sonic/Sri-Lanka-tourism.jpg';

// Gallery 1
import nuwaraEliya from '../assets/pick2/Nuware Eliya/istockphoto-579253918-612x612.jpg';
import sigiriya1 from '../assets/pick2/sigiriya/istockphoto-1492229422-612x612.jpg';
import anuradhapura from '../assets/pick2/Anuradapura/istockphoto-1178654295-612x612.jpg';
import rambodaFalls from '../assets/pick/4.jpg';
import ella1 from '../assets/pick2/Ella/pexels-iakub-arifulin-205356454-11675420.jpg';
import yala from '../assets/pick2/yala/Sri-Lanka-Yala-National-Park-olifanten-safari.webp';
import kandy from '../assets/pick2/kandy/pexels-freestockpro-322437.jpg';
import bodhiViharaya from '../assets/pick/Sri_Maha_Bodhi_Vihara_Statue.jpg';

// Gallery 2
import knuckles from '../assets/pick/istockphoto-2177599886-612x612.jpg';
import udawalawe from '../assets/pick2/udawalawe/istockphoto-904632224-612x612.jpg';

// Gallery 3
import bentota from '../assets/pick2/benthota/Bentota_River_boat_safari_Feachered_1a66874bcb.jpg';
import colombo from '../assets/pick2/colombo/pexels-amayuru-2370934.jpg';
import galle from '../assets/pick2/Galle/istockphoto-472387838-612x612.jpg';
import mirrissa from '../assets/pick2/Mirissa/pexels-ollivves-1005417.jpg';
import jaffna from '../assets/pick/5.jpg';
import polonnaruwa from '../assets/pick2/polonnaruwa/istockphoto-1184393376-612x612.jpg';
import turtle from '../assets/pick2/turtle/istockphoto-1170317746-612x612.jpg';
import ambuluwawaTower from '../assets/pick2/Ambuluwawa/b8b15f8ac9dea867fa967e7fd0c36b6793d914541adf48cf31358408e01c93a1.avif';

// Gallery 4
import polgampala from '../assets/pick/44.jpg';
import beach from '../assets/pick/43.jpg';

// === MOTION VARIANTS ===
const sectionVariants = {
    hidden: { opacity: 0, y: 60 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.9, ease: "easeOut" } },
};

const Gallery = () => {
    const { t } = useTranslation('gallery'); // Use gallery namespace
    const [index, setIndex] = useState(-1);
    const location = useLocation();

    // === GALLERY DATA ===
    const gallery1 = [
        { image: nuwaraEliya, label: t('nuwaraEliya'), span: "col-span-1 row-span-1" },
        { image: sigiriya1, label: t('sigiriya'), span: "col-span-1 row-span-2" },
        { image: anuradhapura, label: t('anuradhapura'), span: "col-span-1 row-span-1" },
        { image: rambodaFalls, label: t('rambodaFalls'), span: "col-span-1 row-span-2" },
        { image: ella1, label: t('ella'), span: "col-span-1 row-span-2" },
        { image: yala, label: t('yala'), span: "col-span-1 row-span-2" },
        { image: kandy, label: t('kandy'), span: "col-span-1 row-span-1" },
        { image: bodhiViharaya, label: t('bodhiViharaya'), span: "col-span-1 row-span-1" },
    ];

    const gallery2 = [
        { image: knuckles, label: t('knuckles') },
        { image: udawalawe, label: t('udawalawe') },
    ];

    const gallery3 = [
        { image: bentota, label: t('bentota'), span: "col-span-1 row-span-1" },
        { image: colombo, label: t('colombo'), span: "col-span-1 row-span-2" },
        { image: galle, label: t('galle'), span: "col-span-1 row-span-1" },
        { image: mirrissa, label: t('mirissa'), span: "col-span-1 row-span-2" },
        { image: jaffna, label: t('jaffna'), span: "col-span-1 row-span-2" },
        { image: ambuluwawaTower, label: t('ambuluwawaTower'), span: "col-span-1 row-span-2" },
        { image: turtle, label: t('turtle'), span: "col-span-1 row-span-1" },
        { image: polonnaruwa, label: t('polonnaruwa'), span: "col-span-1 row-span-1" },
    ];

    const gallery4 = [
        { image: polgampala, label: t('polgampala') },
        { image: beach, label: t('beach') },
    ];

    // Combine all for Lightbox
    const allImages = [...gallery1, ...gallery2, ...gallery3, ...gallery4];
    const slides = allImages.map(item => ({
        src: item.image,
        width: 1600,
        height: 1067,
        alt: item.label,
        title: item.label,
    }));

    const g1 = gallery1.length;



    return (
        <div className="bg-[#001F3F] min-h-screen">
            {/* HERO SECTION */}
            <motion.section
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                variants={sectionVariants}
                className="relative h-[700px] w-full bg-cover bg-center md:h-screen md:max-h-[740px] lg:max-h-[800px] xl:max-h-[960px] overflow-hidden"
                style={{ backgroundImage: `url(${galleryHeroImage})` }}
            >
                <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/50 to-black/80" />

                <div className="container relative mx-auto px-4 h-full flex items-end justify-end pb-24 md:pb-36 lg:pb-44">
                    <div className="text-right max-w-3xl">
                        <h1
                            className="font-konkhmer text-[3.125rem] uppercase md:text-5xl lg:text-[5.5rem] xl:text-[6.5rem] font-bold leading-tight text-[#7FDBFF]"

                        >
                            {t('heroTitle')}
                        </h1>
                        <div className="mt-6 max-w-[700px] ml-auto">
                            <p className="font-inknut text-sm leading-7 text-white/90 md:text-base lg:text-lg lg:leading-8">
                                {t('heroSubtitle')}
                            </p>

                        </div>
                    </div>
                </div>

                {/* Gradient Corner SVGs */}

            </motion.section>

            {/* GALLERY CONTENT */}
            <div className="container mx-auto px-4 py-16 lg:py-24">
                {/* Tabs */}
                <div className="flex items-center justify-center gap-6 font-redHatDisplay text-2xl font-bold uppercase md:text-3xl lg:text-4xl">
                    <Link
                        to="/gallery"
                        className={`pb-3 border-b-4 transition-all duration-300 ${location.pathname === "/gallery"
                            ? "border-[#7FDBFF] text-[#7FDBFF]"
                            : "border-transparent text-white/70 hover:text-[#0074D9]"
                            }`}
                    >
                        {t('tabPlaces')}
                    </Link>
                    <span className="text-white/40 text-3xl">/</span>
                    <Link
                        to="/events"
                        className={`pb-3 border-b-4 transition-all duration-300 ${location.pathname === "/events"
                            ? "border-[#7FDBFF] text-[#7FDBFF]"
                            : "border-transparent text-white/70 hover:text-[#0074D9]"
                            }`}
                    >
                        {t('tabEvents')}
                    </Link>
                </div>

                {/* Gallery grids remain the same — only labels are translated via t() */}
                {/* GALLERY 1 */}
                <div className="mt-16 grid auto-rows-[180px] grid-cols-2 gap-4 md:auto-rows-[260px] md:grid-cols-3 md:gap-5 lg:auto-rows-[440px] lg:gap-7 xl:gap-8">
                    {gallery1.map((item, i) => (
                        <motion.button
                            key={i}
                            whileHover={{ scale: 1.05, y: -6 }}
                            whileTap={{ scale: 0.96 }}
                            onClick={() => setIndex(i)}
                            className={`group relative overflow-hidden rounded-2xl shadow-2xl transition-all duration-500 ${item.span || ''}`}
                        >
                            <img
                                src={item.image}
                                alt={item.label}
                                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-115"
                                loading="lazy"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                            <div className="absolute bottom-0 left-0 right-0 p-5 text-left">
                                <h3 className="font-konkhmer text-lg font-bold uppercase text-white drop-shadow-xl md:text-xl lg:text-2xl">
                                    {item.label}
                                </h3>
                            </div>
                        </motion.button>
                    ))}
                </div>

                {/* GALLERY 2, 3, 4 — same pattern */}
                {/* ... (rest of galleries unchanged, just using translated labels from t()) */}
                {/* Only the label comes from t(), everything else is identical */}

                {/* GALLERY 2 */}
                <div className="mt-10 flex flex-col gap-4 md:mt-16 md:flex-row md:gap-6 lg:gap-8">
                    {gallery2.map((item, i) => (
                        <motion.button
                            key={i}
                            whileHover={{ scale: 1.04, y: -6 }}
                            whileTap={{ scale: 0.96 }}
                            onClick={() => setIndex(g1 + i)}
                            className="group relative h-[240px] w-full overflow-hidden rounded-2xl shadow-2xl md:h-[460px] md:w-1/2"
                        >
                            <img src={item.image} alt={item.label} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-115" loading="lazy" />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                            <div className="absolute bottom-0 left-0 right-0 p-6 text-left">
                                <h3 className="font-konkhmer text-xl font-bold uppercase text-white drop-shadow-xl md:text-2xl lg:text-3xl">
                                    {item.label}
                                </h3>
                            </div>
                        </motion.button>
                    ))}
                </div>

                {/* GALLERY 3 & 4 — same as above */}
                {/* ... */}
            </div>

            {/* LIGHTBOX */}
            <Lightbox
                open={index >= 0}
                close={() => setIndex(-1)}
                index={index}
                slides={slides}
                plugins={[Thumbnails, Zoom]}
                thumbnails={{ position: "bottom", width: 110, height: 80, border: 3, borderRadius: 12, padding: 6, gap: 16, imageFit: "cover" }}
                zoom={{ maxZoomPixelRatio: 4 }}
                styles={{
                    container: { backgroundColor: "rgba(0, 31, 63, 0.98)" },
                    thumbnail: { cursor: "pointer", background: "linear-gradient(45deg, #0074D9, #7FDBFF)", borderRadius: "12px", overflow: "hidden", boxShadow: "0 4px 15px rgba(0,0,0,0.4)" },
                    thumbnailsContainer: { backgroundColor: "rgba(0, 31, 63, 0.9)", padding: "12px 0", borderTop: "1px solid rgba(255,255,255,0.1)" },
                }}
                labels={{
                    close: t('lightboxClose') || "Close",
                    next: t('lightboxNext') || "Next",
                    previous: t('lightboxPrevious') || "Previous",
                }}
                controller={{ closeOnBackdropClick: true }}
            />
        </div>
    );
};

export default Gallery;